import React from 'react'
import GetTeam from '/src/utils/GetTeam';
import WithLargeImagesTeamMember from './WithLargeImagesTeamMember'

const WithLargeImagesAll = (props) => {

    return(
        <div className="relative w-full h-full overflow-hidden">
            {props.tags.map((tag, index) => {
                return (
                    <div className={`relative h-auto ${tag === props.currentFilter ? 'visible' : 'invisible !h-0'}`} key={index}>
                        <ul className={`space-y-8 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8 transition-opacity duration-300 ${tag === props.currentFilter ? 'opacity-100' : 'opacity-0'}`}>
                            {GetTeam(props.team).map((item, index) => {
                                if (item.tag_list.includes(tag)) {
                                    return(
                                        <WithLargeImagesTeamMember {...item} key={index}/>
                                    )
                                } else return null
                            })}
                        </ul>
                    </div>
                )
            })}
        </div>
    )
};

export default WithLargeImagesAll